import React, { Fragment, useEffect, useState } from 'react';
import { Pagination } from '@material-ui/lab';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import './history.scss';
import Collapse from '@material-ui/core/Collapse';
import Fade from '@material-ui/core/Fade';

import { HISTORY_STATUS, STATUS_CLASSNAME } from './constants';
import { MOCK_DATA } from './mock-data';
import { commonService } from 'services/lootbox/commonService';
import common from 'reducers/loobox/common';
import { Table, Tag, Space, Card } from 'antd';
import {useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';

export default function History() {
  const { t, i18n } = useTranslation('common');
  const [histories, setHistories] = useState([]);
  const [page, setPage] = useState(1);
  const [checked, setChecked] = React.useState(true);
  const [hidden, setHidden] = useState(false);
  const {id} = useParams()
  const { language } = useSelector(({ coreui }) => coreui);
  const [his, setHis] = useState(null);
  const [expanRowKey,setExpan] = useState([])
  
  const handlePageChange = (event, newPageIndex) => {
    setHidden(true);
    setTimeout(() => {
      setHidden(false);
      setPage(newPageIndex);
      setChecked((prev) => !prev);
    }, 300);
    
  };
  const handleValue=(data)=>{
    return data.substr(0,6) +"..."+ data.substr(data.length - 6, data.length-1)
  }

  const elHeight = document.getElementsByClassName('history--table--item--container').clientHeight;

  useEffect(async() => {
    const history = await commonService.historyList();
    const temp = [];
    history.data.map(m =>{
      temp.push({...m, key: m.id})
    })
    temp.sort((a,b)=>{
      return new Date(b.CreatedAt) - new Date(a.CreatedAt);
    }) 
    setHistories(temp)
    setPage(1)
  }, []);
  useEffect(async()=>{
    if(id){
      const res =await commonService.history(id)
      let key= [];
      debugger

      if(expanRowKey.includes(id)){
        key.push([]);
      }else{
        key.push(parseInt(id));
      }
      
      setExpan(key)
      setHis(res.data.orderdetails)
    }
  },[id])

  const _renderHistoryItems = (historyItems, page) =>
    historyItems.slice((page - 1) * 4, page * 4).map((item) => {
      return (
        <Grid
          container
          key={item.id}
          className={`history--table--item--container ${hidden ? 'hidden' : ''}`}
          justifyContent='center'
          alignItems='center'
        >
          <Grid item xs={3} className='text-left history--table--text' style={{ 'word-break': 'break-all', 'padding' : '0px 5px' }}>
            {handleValue(item.transaction_hash)}
          </Grid>          
          <Grid item xs={3} className='text-center history--table--date'>
            {moment(item.CreatedAt).format('HH:mm DD/MM/yyyy')}
          </Grid>          
          {/* <Grid item xs={2} className='text-left history--table--text' style={{ 'word-break': 'break-all', 'padding' : '0px 5px' }}>
            {item.id}
          </Grid> */}
          {/* <Grid item xs={1} className='text-center history--table--text'>
            {item.total_amount}
          </Grid> */}
          {/* <Grid item xs={1} className='text-right history--table--price'>
              {item.total_amount}
          </Grid>           */}
          <Grid item xs={3} className='text-center history--table--price'>
              {item.total_amount} {item.currency}
          </Grid>
          <Grid item xs={3} className='text-center d-flex justify-content-center'>
            <div className={`history--status ${STATUS_CLASSNAME[item.status]}`}>
              <span className='history--status--text d-flex flex-column justify-content-center'>
                {item.status && item.status === 3 ? "Approved" : item.status ===2?"pending":"Rejected"}
              </span>
            </div>
          </Grid>
        </Grid>
      );
    });

    const columns = [
      {
        title: t('history.transaction_id'),
        dataIndex: 'transaction_hash',
        key: 'transaction_hash',
        render(h) {
          if(h == "" || !h){
            return ""
          }
        return  handleValue(h)
        },
      },
      {
        title: t('history.date'),
        dataIndex: 'CreatedAt',
        key: 'CreatedAt',
        render(h) {
         return moment.utc(h).format('HH:mm DD/MM/yyyy')
        }
      },
      {
        title: t('history.value'),
        dataIndex: 'total_amount',
        key: 'total_amount',
        render(h,record) {
         return <Fragment><NumberFormat value={h} displayType={'text'} thousandSeparator={true} /> {record.currency}</Fragment> 
        },
      },
      {
        title: t('history.status'),
        dataIndex: 'status',
        key: 'Status',
        render(h) {
        return  <div className={`history--status ${STATUS_CLASSNAME[h]}`}>
              <span className='history--status--text d-flex flex-column justify-content-center'>
                {h && h === 3 ? "Approved" : h ===2?"pending":"Rejected"}
              </span>
            </div>
        },
      },
      
    ];

    const columns2 = [
      {
        title: t('history.name'),
        dataIndex: 'product_name',
        key: 'product_name',
        render(h,record){
          return language && language != "jp"? record.product_name:record.name_simplified_chinese
        }
      },
      {
        title: t('history.amount'),
        dataIndex: 'quantity',
        key: 'quantity'
      },
      {
        title: t('history.price'),
        dataIndex: 'price',
        key: 'price',
        render(h,record) {
         return <Fragment><NumberFormat value={h} displayType={'text'} thousandSeparator={true} /> {record.currency}</Fragment>
        },
      },
      {
        title: t('history.totalvalue'),
        dataIndex: 'total_amount',
        key: 'total_amount',
        render(h,record) {
         return <Fragment><NumberFormat value={record.price * record.quantity} displayType={'text'} thousandSeparator={true} /> {record.currency}</Fragment>
        },
      },
      
    ];

    const handleOnExpan= async(a,record)=>{
      const res =await commonService.history(record.id)
      debugger
      let key= [];
      if(expanRowKey.includes(record.id)){
        key.push([]);
      }else{
        key.push(record.id);
      }
      
      setExpan(key)
      setHis(res.data.orderdetails)
    }
    const expandedRow = row => {
     
      return <Table columns={columns2} dataSource={his}  pagination={false} />;
    };

  return (
    // <Grid className='history--container mx-auto'>
    //   <span className='history--title'>Orders History</span>
    //   <Grid container className='history--table--header'>
    //     <Grid item xs={3} className='text-left'>
    //       <span>Transaction Id</span>
    //     </Grid>
    //     <Grid item xs={3} className='text-center'>
    //       <span>Date</span>
    //     </Grid>                
    //     {/* <Grid item xs={2} className='text-left'>
    //       <span>Item</span>
    //     </Grid> */}
    //     {/* <Grid item xs={2} className='text-center'>
    //       <span>Total amount</span>
    //     </Grid>
    //     <Grid item xs={2} className='text-center'>
    //       <span>Price<br /> (USDC/USDT)</span>
    //     </Grid>         */}
    //     <Grid item xs={3} className='text-center'>
    //       <span>Total Value</span>
    //     </Grid>
    //     <Grid item xs={3} className='text-center'>
    //       <span>Status</span>
    //     </Grid>
    //   </Grid>
    //   <Collapse in={checked} collapsedSize={elHeight * MOCK_DATA.slice((page - 1) * 8, page * 8).length}>
    //     {_renderHistoryItems(histories, page)}
    //     <Grid container justifyContent='center'>
    //       <Pagination count={Math.ceil(histories.length / 4)} shape='rounded' page={page} onChange={handlePageChange} />
    //     </Grid>
    //   </Collapse>
    // </Grid>
    <Fragment>
      
     <div className="order-history">
      <h2>{t('history.orderhistory')}</h2>
        {<Card className="col-12">
         <Table columns={columns} expandable={{
          expandedRowRender: expandedRow,
          defaultExpandedRowKeys:expanRowKey,
          expandedRowKeys: expanRowKey,
          
          onExpand: (a,b) => handleOnExpan(a,b),
          expandRowByClick:true
        }} dataSource={histories} />
       </Card>}
     </div>
    </Fragment>
  );
}
